import type { Manifest } from "./tools";

/** Keep native text bounds and their visible counter on the published tool contract. */
export function inputMaxLength(manifest: Manifest | null, tool: string, field: string): number | undefined {
  type TextSchema = { maxLength?: unknown; anyOf?: TextSchema[] };
  const schema = manifest?.tools.find(entry => entry.name === tool)?.inputSchema;
  const properties = schema?.["properties"] as Record<string, TextSchema> | undefined;
  const property = properties?.[field];
  const limit = property?.maxLength ?? property?.anyOf?.find(branch => typeof branch.maxLength === "number")?.maxLength;
  return typeof limit === "number" && Number.isInteger(limit) && limit > 0 ? limit : undefined;
}

export function inputLengthHint(value: string, limit: number | undefined): string | undefined {
  return limit === undefined ? undefined : `${value.length} of ${limit} characters. Maximum ${limit}.`;
}
